<template>
  <el-header>
    <div class="title">管理系统后台</div>
    <Nav></Nav>
    <div class="user-service">
      <el-dropdown>
        <span>admin<i class="el-icon-arrow-down el-icon--white"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <el-button type="text" @click="logout()">退出</el-button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-header>
</template>

<script>
import Nav from './nav'
export default {
  components: {Nav},
  methods: {
    logout() {
        //清除token
        this.$store.dispatch('UserLogout');
        if (!this.$store.state.token) {
            this.$router.push('/login')
            this.$message({
                type: 'success',
                message: '退出成功'
            })
        } else {
            this.$message({
                type: 'info',
                message: '退出失败'
            })
        }
    },
  }
}
</script>

<style scoped>
.el-header {
  font-size: 14px;
  background-color: #324053;
  color: #333;
  line-height: 60px;
}
.title {
  font-size: 25px;
  width: 180px;
  color: white;
  display: inline-block;
  float: left;
}
.user-service {
  text-align: right;
  width: 100px;
  display: inline-block;
  float: right;
}
.user-service span {
  color: #ddd;
}
.user-service span:hover {
  color: #fff;
}
.user-service span i {
  padding-left: 10px;
}
</style>>


// WEBPACK FOOTER //
// src/views/server_web/layout/header.vue